import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import isotipo from '../../../../assets/images/isotipo_transp.png';

export const HomeButton: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const handleClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
    }
  };

  return (
    <Tooltip label={t('header.goHome')}>
      <Button
        variant="subtle"
        p={0}
        w={40}
        h={40}
        style={{ aspectRatio: '1/1' }}
        onClick={handleClick}
      >
        <img
          src={isotipo}
          alt={t('header.logo')}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
          }}
        />
      </Button>
    </Tooltip>
  );
};
